module.exports = __webpack_public_path__ + "media/images/icon-caret-down-d8671fab9fdba09f2b4097cdad095fc7.svg";